var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMongodbScoreLow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3355_10943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#3260E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7863 18.7983C24.3786 12.4917 21.4424 10.8136 20.6938 9.62648C20.3848 9.10325 20.1113 8.55987 19.875 8C19.8354 8.56031 19.7634 8.91386 19.2935 9.33847C18.352 10.1905 14.3515 13.4997 14.0137 20.6647C13.7008 27.3451 18.8532 31.4649 19.5335 31.8895C20.0578 32.1516 20.6947 31.8959 21.0058 31.6559C23.4888 29.9261 26.8828 25.3134 25.789 18.7973",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7863 18.7983C24.3786 12.4917 21.4424 10.8136 20.6938 9.62648C20.3848 9.10325 20.1113 8.55987 19.875 8C19.8354 8.56031 19.7634 8.91386 19.2935 9.33847C18.352 10.1905 14.3515 13.4997 14.0137 20.6647C13.7008 27.3451 18.8532 31.4649 19.5335 31.8895C20.0578 32.1516 20.6947 31.8959 21.0058 31.6559C23.4888 29.9261 26.8828 25.3134 25.789 18.7973",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0772 32C20.3812 31.6637 20.18 30.088 20.1495 28.6192C20.3212 26.1972 20.3711 23.7668 20.3 21.3392C20.2631 20.0655 20.3166 9.54036 20 8C20.2169 8.52212 20.4661 9.02845 20.7477 9.51434C21.4889 10.7277 24.3955 12.4427 25.7893 18.8819C26.8748 25.5246 23.5334 30.2218 21.0772 32Z",
    fill: "#3260E6",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3355_10943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMongodbScoreLow);
export default __webpack_public_path__ + "static/media/ico-mongodb-score-low.d0a901b9.svg";
export { ForwardRef as ReactComponent };